import React from "react";
import PropTypes from "prop-types";
import { RadioButton } from "../../../components/RadioButton";

/**
 * Settings which are "Show Poster Name" & "Show Comments"
 * @param {GeneralAppearance.propTypes} props
 */
export const GeneralAppearance = (props) => {
	return (
		<div className="grid grid-cols-2">
			<div>
				<div className="font-bold mb-3">Show Poster Name</div>
				<div className="grid grid-cols-3 mb-8">
					<RadioButton
						isChecked={props.value.showPosterName}
						onCheck={() =>
							props.onChange({
								...props.value,
								showPosterName: true,
							})
						}
						label="Yes"
						color="plugin-3"
					/>
					<RadioButton
						isChecked={!props.value.showPosterName}
						onCheck={() =>
							props.onChange({
								...props.value,
								showPosterName: false,
							})
						}
						label="No"
						color="plugin-3"
					/>
				</div>
			</div>
			<div>
				<div className="font-bold mb-3">Show Comments</div>
				<div className="grid grid-cols-3 mb-8">
					<RadioButton
						isChecked={props.value.showComments}
						onCheck={() =>
							props.onChange({
								...props.value,
								showComments: true,
							})
						}
						label="Yes"
						color="plugin-3"
					/>
					<RadioButton
						isChecked={!props.value.showComments}
						onCheck={() =>
							props.onChange({
								...props.value,
								showComments: false,
							})
						}
						label="No"
						color="plugin-3"
					/>
				</div>
			</div>
		</div>
	);
};

GeneralAppearance.propTypes = {
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
};
